import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
  updatePendingPublicInquirySuccessAction,
  setPendingPublicInquiryCountAction,
  setPendingPublicInquiryIsLoadingAction,
  getPendingPublicInquiriesSuccessAction,
  getSinglePendingPublicArtisanInquirySuccessAction,
  deleteSingleArtisanPublicInquirySuccessAction,
  moderateCreateArtisanPublicSuccessAction
} from './Actions';
import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../notifications/Actions';
import { authUserIdSelector } from '../../auth/Selectors';
import { push } from 'react-router-redux';
import { actions } from './Reducer';
import * as api from './Api';


function* getPendingPublicinquiries({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    sort: 'createdAt',
    dir: 'asc',
    searchTerm: '',
    filterBy: [],
    filterCountry: '',
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingPublicInquiryIsLoadingAction(true));
    const response = yield call(api.getPublicInquiries, body);
    const { data } = response;
    const { content, count } = data;
    yield put(getPendingPublicInquiriesSuccessAction(content));
    yield put(setPendingPublicInquiryCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPublicInquiryIsLoadingAction(false));
  }
}

// function* updatePendingPublicinquiry({ payload }) {
//   const moderatorID = yield select(authUserIdSelector);
//   const defData = {
//     moderatorID,
//   };

//   const body = { ...defData, ...payload };

//   try {
//     yield put(setPendingPublicInquiryIsLoadingAction(true));
//     yield call(api.updatePublicInquiry, body);
//     yield put(updatePendingPublicInquirySuccessAction(body.moderationRecordID));
//     yield put(newSuccessNotificationAction('Inquiry Moderated'));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setPendingPublicInquiryIsLoadingAction(false));
//   }
// }

function* getSinglePublicArtisanInquiry({ payload }) {
  const id = payload;
  try {
    yield put(setPendingPublicInquiryIsLoadingAction(true));
    const response = yield call(api.getSinglePendingPublicArtsianInquiry, id);
    const { data } = response;
    yield put(getSinglePendingPublicArtisanInquirySuccessAction(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPublicInquiryIsLoadingAction(false));
  }
}

function* deleteSinglePendingArtisanPublicInquiry({ payload }) {
  const {_id} = payload;
  try {
    yield put(setPendingPublicInquiryIsLoadingAction(true));

    yield call(api.deleteSingleArtisanPublicInquiry, payload);
    yield put(deleteSingleArtisanPublicInquirySuccessAction(_id));
          yield put(newSuccessNotificationAction('Inquiry Deleted'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPublicInquiryIsLoadingAction(false));
  }
}

function* moderateCreateArtisanPublicInquiry({ payload , mode}) {
  const id = payload;
  try {
    yield put(setPendingPublicInquiryIsLoadingAction(true));
    if (mode === 'update') {
   const response = yield call(
        api.moderateUpdateSingleArtisanPublicIquiry,
        id
      );
      const { data } = response;
      yield put(moderateCreateArtisanPublicSuccessAction(id));
      yield put(newSuccessNotificationAction('Inquiry Update Moderated'));
      yield put(push('/artisans-moderation/public-inquiry'));
    } else {

      const response = yield call(
        api.moderateCreateSingleArtisanPublicIquiry,
        id
      );
      const { data } = response;
      yield put(moderateCreateArtisanPublicSuccessAction(id));
      yield put(newSuccessNotificationAction('Inquiry Moderated'));
      yield put(push('/artisans-moderation/public-inquiry'));
    }
  } catch (error) {
  } finally {
    yield put(setPendingPublicInquiryIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(
    actions.GET_PENDING_ARTISANS_PUBLIC_INQUIRIES,
    getPendingPublicinquiries
  );

  // yield takeLatest(
  //   actions.UPDATE_PENDING_ARTISAN_PUBLIC_INQUIREY,
  //   updatePendingPublicinquiry
  // );
  yield takeLatest(
    actions.GET_SINGLE_ARTISAN_PUBLIC_INQUIRY,
    getSinglePublicArtisanInquiry
  );
  yield takeLatest(
    actions.DELETE_SINGLE_ARTISAN_PUBLIC_INQUIRY,
    deleteSinglePendingArtisanPublicInquiry
  );
  yield takeLatest(actions.MODERATE_CREATE_ARTISAN_PUBLIC_INQUIRY,moderateCreateArtisanPublicInquiry);
}
